export default class SocieteFormNiveauxController {
    static $inject = ['SocietesService', 'notification'];

    constructor(SocietesService, notification) {
        this.SocietesService = SocietesService;
        this.notification = notification;
    }

    $onInit() {
        // Propriétés
        this.loading = true;
        this.societe = this.societe || {};
        this.values = angular.copy(this.societe.niveaux);
        this.niveaux = this.niveaux || [];
        this.elements = this.elements || [];
    }

    $onChanges(objChanges) {
        if (objChanges.societe) {
            this.loadNiveaux();
        }
    }

    $doCheck() {
        if (!angular.equals(this.values, this.societe.niveaux)) {
            this.onUpdate({
                niveaux: angular.copy(this.values)
            });
        }
    }

    async loadNiveaux() {
        this.startLoading();

        try {
            this.niveaux = await this.SocietesService.getSocietesNiveaux();
            this.elements = await this.SocietesService.getSocietesElements();
        } catch (ex) {
            this.notification.error(ex);
        } finally {
            this.stopLoading();
        }
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
